//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SvgIcons from './SvgIcons.svg';

if (typeof document !== 'undefined' && !document.getElementById('SvgIcons')) {
  document.body.insertAdjacentHTML('beforeend', SvgIcons);
}

export default {
  name: 'VftSvgIcons',
  props: {
    type: String
  }
};